import { createStore } from '@datorama/akita';
import packageInfo from '../../../package.json';

export interface ApplicationContextState {
   loading: boolean;
   version: string;
   [key: string]: any;
}

export default createStore<ApplicationContextState>(
   {
      loading: true,
      version:
         process.env.NODE_ENV !== 'production'
            ? `${process.env.npm_package_version ?? packageInfo?.version} next`
            : (process.env.npm_package_version ?? packageInfo?.version),
   },
   { name: 'applicationContext' }
);
